import React from 'react'
import css from './style.scss'
import PlayIcon from 'react-icons/lib/md/play-arrow'


export default (props)=>{
  return (
    <div className={css.loading}></div>
  )
}


export const VideoLoading=(props)=>{
  let style={}
  if(props.videoThumb){
    style={backgroundImage:"url("+props.videoThumb+")"}
  }
  return (
    <div onClick={props.onClick} className={css.loading} style={style}>
      <div className={css.wrapper}>
        <PlayIcon size={64}></PlayIcon>
      </div>

    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/account_page/story_details/loading.js